<template>
  <div id="app">
    <div id="background"></div>
    <div class="main">
      <img src="@/assets/logo-t.png" class="logo" />
      <div class="nav">
        <router-link to="/">Start</router-link>
        <router-link to="/kurse">Kurse</router-link>
        <router-link to="/beitraege">Beiträge</router-link>
        <router-link to="/aktivitaeten">Aktivitäten</router-link>
      </div>
      <router-view />
      <div class="footer">
        <p class="footer-item footer-address">
          <span class="styled-underline">
            <span class="footer-header">Freie Musikschule Hahn</span> </span
          ><br />
          <i class="fas fa-map-marker"></i> Am Tann 4<br />
          <i class="fas fa-map-marker-alt"></i> 75328 Langenbrand<br />
          <i class="fas fa-phone fa-rotate-180"></i> 07084 / 934893<br />
          <i class="fas fa-envelope"></i>
          <a href="mailto:info@freiemusikschulehahn.de"
            >info@freiemusikschulehahn.de</a
          >
        </p>
        <p class="footer-item footer-sitemap">
          <span class="styled-underline">
            <span class="footer-header">Informationen</span> </span
          ><br />
          <i class="fas fa-guitar"></i>
          <router-link to="/kurse">Kurse</router-link><br />
          <i class="fas fa-coins"></i>
          <router-link to="/beitraege">Beiträge</router-link><br />
          <i class="fas fa-microphone-alt"></i
          ><router-link to="/aktivitaeten">Aktivitäten</router-link>
        </p>
        <p class="footer-item footer-legal">
          <span class="styled-underline">
            <span class="footer-header">Rechtliche Hinweise</span> </span
          ><br />
          <i class="fas fa-shield-alt"></i>
          <router-link to="/datenschutz">Datenschutz</router-link><br />
          <i class="fas fa-scroll"></i>
          <router-link to="/impressum">Impressum</router-link>
        </p>
        <img src="@/assets/logo-white.png" class="footer-logo" />
        <div class="footer-copyright">
          <i class="fas fa-copyright"></i> {{ new Date().getFullYear() }},
          Alexander Auras für "Freie Musikschule Hahn"
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import Footer from "@/components/Footer.vue";
export default {
  name: "home"
  /* components: {
    Footer
  } */
};
</script>

<style lang="scss">
html,
body {
  margin: 0;
}
* {
  box-sizing: border-box;
}

.clearfix::before,
.clearfix::after {
  content: " ";
  display: table;
}

.clearfix::after {
  clear: both;
}

.clearfix {
  *zoom: 1; /* Für den IE6 und IE7 */
}

#app {
  font-family: "Open Sans", sans-serif;
  font-size: 20px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #55505a;
  height: 100%;
  width: 100%;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: "Source Sans Pro", sans-serif;
    font-style: normal;
    font-weight: normal;
    letter-spacing: 1.5px;
    color: #403a46;
    @media only screen and (max-width: 1280px) {
      line-height: 1.2;
      margin-bottom: 20px;
    }
  }
  h1 {
    font-size: 42px;
  }
  h2 {
    font-size: 34px;
  }

  .site-text {
    line-height: 1.65;
  }

  button {
    display: inline-block;
    font-family: "Open Sans", sans-serif;

    text-decoration: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    cursor: pointer;
    outline: 0;

    border: none;
    box-shadow: inset 0 1.5px 0 hsla(290, 61%, 80%, 1),
      1px 2px 5px rgba(0, 0, 0, 0.4);

    background-color: hsla(290, 71%, 40%, 1);
    margin: 0;
    padding: 12px 30px;

    text-align: center;
    color: #ffffff;
    font-size: 18px;
    letter-spacing: 0.3px;
    text-transform: uppercase;

    transition: background 400ms ease, transform 150ms ease,
      box-shadow 150ms ease;
    &:hover {
      transform: scale(1.02);
      background-color: hsla(290, 71%, 40%, 1);
      box-shadow: 2px 3px 8px rgba(0, 0, 0, 0.5);
    }
    &:active {
      transform: scale(1);
    }

    @media only screen and (max-width: 1280px) {
      width: calc(100% - 60px);
    }

    .fas {
      padding-right: 5px;
    }
  }

  input:not([type="checkbox"]),
  textarea,
  select {
    font-size: 20px;
    padding: 5px 5px;
    border: 1px solid #55505a;
    color: #55505a;
    border-radius: 2px;
    display: block;
    width: 100%;
  }

  input[type="checkbox"] {
    margin: 0 10px 0 0;
    + label:after {
      content: "\A";
      white-space: pre;
    }
  }

  .small {
    font-size: 12px;
    line-height: 1;
  }
}
#background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  /*background: #a96aec;
  background: linear-gradient(
    165deg,
    hsla(281, 70%, 52%, 1) 45%,
    hsla(204, 67%, 52%, 1) 99%
  );*/
  //background: linear-gradient(165deg, hsl(269, 77%, 67%) 45%, hsl(269, 77%, 67%) 99%);
  //background: linear-gradient(165deg, hsla(273, 65%, 67%, 1) 45%, hsla(269, 55%, 85%, 1) 99%);
  background: hsla(231, 48%, 44%, 1);
  background: linear-gradient(
    165deg,
    hsla(231, 48%, 44%, 1) 45%,
    hsla(231, 48%, 32%, 1) 99%
  );
}
.main {
  position: relative;
  width: 1250px;
  margin: 7vh auto;
  background-color: #fff;
  box-shadow: 3px 5px 10px rgba(0, 0, 0, 0.3), 5px 10px 35px rgba(0, 0, 0, 0.5);
  border-radius: 2px;
  @media only screen and (max-width: 1500px) {
    margin: 5vh auto;
  }
  @media only screen and (max-width: 1280px) {
    margin: 0px auto;
    width: 100%;
  }
}

.logo {
  position: absolute;
  z-index: 6;
  left: 56px;
  top: 25px;
  width: 250px;

  @media only screen and (max-width: 1280px) {
    position: relative;
    left: 50%;
    margin: 0 auto;
    transform: translateX(-50%);
  }
}

a.link {
  color: #961eae;
  &:hover,
  &:active {
    color: darken(#961eae, 15%);
  }
}

a.ext-link {
  &::after {
    content: "\f35d";
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    font-size: 12px;
    vertical-align: top;
    padding-left: 5px;
  }
}

.nav {
  position: absolute;
  z-index: 5;
  top: 0;
  right: 0;
  margin: 45px 55px 0 0;

  font-family: "Bitter", serif;
  font-size: 16px;
  letter-spacing: 1px;
  text-transform: uppercase;

  @media only screen and (max-width: 1280px) {
    position: relative;
    margin: 0 0 50px 0;
    top: 50px;
  }

  a {
    color: #fff;
    display: inline-block;
    text-decoration: none;
    margin-left: 30px;
    transition: transform 150ms ease;
    &.router-link-exact-active {
      color: hsla(0, 100%, 68%, 1);
      font-weight: 600;
      border-bottom: 1px solid;
    }
    &:hover {
      border-bottom: 1px solid;
      @media only screen and (max-width: 1280px) {
        border-bottom: none;
      }
    }
    &:active {
      transform: scale(0.95);
      @media only screen and (max-width: 1280px) {
        transform: none;
      }
    }

    @media only screen and (max-width: 1280px) {
      color: #55505a;
      display: block;
      text-align: center;
      margin-left: 0;
      line-height: 40px;

      &.router-link-exact-active {
        border-bottom: none;
        text-decoration: underline;
      }
    }
  }
}

.footer {
  position: relative;
  background: hsla(230, 70%, 13%, 1);
  color: #fff;
  height: 310px;
  padding: 55px 60px;
  font-size: 16px;
  line-height: 1.7;
  @media only screen and (max-width: 1280px) {
    height: auto;
    padding: 30px 30px 120px 30px;
  }
  a {
    color: #fff;
    &:hover,
    &:active {
      color: hsl(291, 70%, 90%);
    }
    &:visited {
      color: #fff;
    }
  }
  .footer-header {
    display: inline-block;
    font-size: 18px;
    margin-bottom: 20px;

    @media only screen and (max-width: 1280px) {
      margin-bottom: 10px;
    }
  }
  .footer-item {
    display: inline-block;
    margin: 0;
    vertical-align: top;

    @media only screen and (max-width: 1280px) {
      display: block;
    }
    + .footer-item {
      margin-left: 60px;
      @media only screen and (max-width: 1280px) {
        margin-left: 0;
        margin-top: 30px;
      }
    }
    .fas {
      width: 20px;
      text-align: center;
      margin-right: 10px;
    }
  }
  .footer-address {
    .fas {
      margin-left: -5px;
    }
    .fa-envelope {
      margin-right: 15px;
    }
  }
  .footer-sitemap,
  .footer-legal {
    a {
      text-decoration: none;
    }
  }
  .footer-logo {
    position: absolute;
    height: 50px;
    right: 60px;
    bottom: 55px;
    @media only screen and (max-width: 1280px) {
      right: 30px;
    }
  }
  .footer-copyright {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 25px;
    text-align: center;
    font-size: 12px;
    opacity: 0.2;
    .fas {
      margin-right: 3px;
    }
  }
  .footer-item.footer-legal {
    margin-left: 124px;
    @media only screen and (max-width: 1280px) {
      margin-left: 0;
    }
  }
  .styled-underline {
    display: inline-block;
  }
}

.styled-underline {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .footer-header {
    display: inline-block;
    position: relative;
    &:after {
      content: "";
      position: absolute;
      left: 15px;
      right: -15px;
      bottom: 0;
      border-bottom: 4px solid #961eae;
      @media only screen and (max-width: 1280px) {
        display: none;
      }
    }
  }
  .footer-header {
    &:after {
      left: 10px;
      right: -10px;
      border-bottom: 2px solid #961eae;
      @media only screen and (max-width: 1280px) {
        display: none;
      }
    }
  }
}

.testimonial {
  margin-left: 25px;
  .testimonial-quote {
    position: relative;
    width: 700px;
    display: inline-block;
    font-family: Georgia;
    font-style: italic;
    @media only screen and (max-width: 1280px) {
      width: 100%;
    }
    span {
      display: inline-block;
      font-size: 60px;
      line-height: 0;
      vertical-align: bottom;
      margin-bottom: 10px;
      color: hsla(290, 53%, 40%, 0.4);
      &:first-child {
        position: absolute;
        top: 20px;
        left: -30px;
      }
    }
  }
  .testimonial-person {
    display: inline-block;
    width: 400px;
    text-align: right;
    @media only screen and (max-width: 1280px) {
      margin-top: 10px;
      width: 100%;
    }
    img {
      width: 80px;
      border-radius: 50%;
    }
    .testimonial-person-name {
      color: #961eae;
      font-weight: 600;
    }
    .testimonial-person-description {
      font-size: 14px;
    }
  }
}
</style>
